<p>forgot-password-page works!</p>
